import { expressQuerySelector } from "../../common/html";
import { createGeneralPageEventsAndComponents } from "../technical/page-general";

window.addEventListener("DOMContentLoaded", async () => {
	const generalPageComponents = createGeneralPageEventsAndComponents();
	generalPageComponents.disableLeaveIntent();

	const popupEl = expressQuerySelector<HTMLElement>(document, ".technical-locatephotos-popup", false);
	if (!popupEl) return;

	const mediaStorePartnerName = popupEl.dataset.mediastorepartnername || "";
	const mediaStorePartnerType = parseInt(popupEl.dataset.mediastoretype || "0", 10);
	const iscommingfrompartnerauthentication = popupEl.dataset.iscommingfrompartnerauthentication === "true";
	const loggedin = popupEl.dataset.loggedin === "true";
	const unableToConnectToPartner = popupEl.dataset.unabletoconnecttopartner === "true";
	let closeWindow = false;

	if (unableToConnectToPartner) {
		const bc = new BroadcastChannel("connectedToStorePartner");
		bc.postMessage({
			command: "ImportPhotosPopUpError",
			detail: {
				errorCode: "unableToConnectToPartner",
			},
		});

		closeWindow = true;
	} else if (loggedin) {
		const bc = new BroadcastChannel("connectedToStorePartner");
		bc.postMessage({ command: "ConnectedToStorePartner", storeType: mediaStorePartnerType });

		closeWindow = true;
	} else if (iscommingfrompartnerauthentication) {
		if (window.opener && window.opener.PartnerAuthenticationCompleted) {
			window.opener.PartnerAuthenticationCompleted(mediaStorePartnerName, false);
		} else {
			closeWindow = true;
		}
	}

	// Close the window
	if (closeWindow) {
		if (window.opener && window.opener.ClosePartnerWindow) {
			window.opener.ClosePartnerWindow();
		} else {
			window.open("", "_self", "");
			window.close();
		}
	}
});
